module.exports = __webpack_public_path__ + "img/img4.1d724046.svg";